export const findObjectInArray = (array, objName) => {
  try {
    const findObj = array.find((obj) => objName in obj);
    const value = findObj ? findObj[objName] : undefined;
    return value;
  } catch (e) {
    return undefined;
  }
};
